import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import * as moment from 'moment';
import { fetchApi } from '../services/api';
import LoadingPanel from '../components/LoadingPanel';
import Receipt from './Receipt';
import { ReceiptData } from './Accounts/ReceiptsPreview';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>

type State = {
    receipts: ReceiptData[];
    errors: AlertData[];
    year: Date|null;
    isLoading: boolean;
}

type AlertData = {
    Message: string;
    Link: string;
}

export default class Receipts extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,
            receipts: [],
            errors: [],
            year: new Date(),
        }
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Receipts" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto">
                    <label>Receipt Year&nbsp;</label>
                    <DatePicker
                        format="yyyy"
                        formatPlaceholder="formatPattern"
                        value={this.state.year}
                        onChange={(e) => {
                            this.setState({ year: e.value }, () => this.requestReceipt());
                        }}
                    />
                </div>
                <div className="col-auto ml-auto">
                    <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Receipt(s)</button>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            {this.state.receipts.map((receipt, index) => {
                return this.state.year && <Receipt key={index} receipt={receipt} />
            })}
        </React.Fragment>
    }

    public componentDidMount() {
        this.requestReceipt();
    }

    private requestReceipt() {
        if (this.state.year) {
            const data = {
                FacilityID: localStorage.getItem("FACILITY_ID")
            }
            if (data.FacilityID) {
                this.setState({ isLoading: true });
                fetchApi(`/api/Account/TaxReceipt/${moment(this.state.year).format('YYYY')}`, data, 'POST')
                    .then((response: { Receipts: ReceiptData[] }) => {
                        this.setState({ isLoading: false, receipts: response.Receipts, errors: [] });
                    });
            } else {
                this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }] });
            }
        }
    }
}
